import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../config/axios"
import { useNavigate, useParams } from "react-router-dom";
import Careernavbar from "./update_details/Careernavbar";
import TimelineItem, { CareerStepItem } from "../Timeline";
import { ToastContainer, toast } from "react-toastify";
import { PersonaldetailsAdd, EducationdetailsAdd, WorkexperienceAdd, Documentdetails } from "./CareerComponent";
import { CustomTooltip, formatCurrencyIndian, handleErrorToast } from "../CustomFunctions";
import { DropdownArrow, InfoIcon } from "../AllSvg";
import Loader from "../Loader";


const PersonaldetailsBackup = () => {
    let { id, email } = useParams()
    return (
        <>
            <Careernavbar id={id} />
            <div className="jd">
                {/*  ************** timeline Seaction Start  ************** */}
                <div className="jd-timeline">
                    <TimelineItem heading="Personal Information" color="#2576BC" />
                    <div className="jd-timeline-border timeline-color"></div>

                    <TimelineItem heading="Position Information" color="#707070" />
                    <div className="jd-timeline-border"></div>

                    <TimelineItem heading="Education Detail" color="#707070" />
                    <div className="jd-timeline-border"></div>

                    <TimelineItem heading="Work Experience" color="#707070" />
                    <div className="jd-timeline-border"></div>

                    <TimelineItem heading="Documents Upload" color="#707070" />
                </div>
                {/*  ************** timeline Seaction Close ************** */}
                <PersonaldetailsAdd email={email} id={id} forwardroutepath="positiondetails" />
            </div >

        </>
    );
};

const Personaldetails = () => {
    let { id, email } = useParams()
    return (
        <>
            <Careernavbar id={id} />
            <div className="career-form-container">
                <div className="career-stepper-container">
                    <div className="career-stepper-line"></div>
                    <CareerStepItem
                        step="1"
                        heading="Personal Information"
                        status="active"
                    />
                    <CareerStepItem
                        step="2"
                        heading="Position Information"
                        status="pending"
                    />
                    <CareerStepItem
                        step="3"
                        heading="Education Detail"
                        status="pending"
                    />
                    <CareerStepItem
                        step="4"
                        heading="Work Experience"
                        status="pending"
                    />
                    <CareerStepItem
                        step="5"
                        heading="Documents Upload"
                        status="pending"
                    />
                </div>
                <PersonaldetailsAdd
                    email={email}
                    id={id}
                    forwardroutepath="positiondetails"
                />
            </div>
        </>
    );
};

const Positiondetails = () => {

    let { id, email } = useParams()

    const [data, setData] = useState(false)
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [formData, setFormData] = useState({
        currentCTC: "",
        monthlyinhand: "",
        expectedCTC: "",
        applyingForPosition: "",
        areaOfInterest: "",
        noticePeriod: "",
        availableToJoin: "",
        workedBefore: false,
        workedBeforeInfo: "",
        yearofExp: "",
        bestAchieve: "",
        awardAchieve: "",
        accomplishments: "",
    });


    const getUSerDetails = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/userdata/positiondata/${email}/`)
            setFormData(res.data);
            setData(true)
        } catch (err) {
            console.error('Error fetching user data:', err);
            // handleErrorToast(err)
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    useEffect(() => {
        getUSerDetails();
    }, [email]);

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    // Validation functions
    const validateCTC = (ctc) => {
        if (!ctc) return true; // Optional field
        const ctcNum = Number(ctc);
        return !isNaN(ctcNum) && ctcNum >= 0 && ctcNum <= 10000000; // Max 1 crore
    };

    const validateExpectedCTC = (ctc) => {
        if (!ctc) return false;
        const ctcNum = Number(ctc);
        return !isNaN(ctcNum) && ctcNum >= 0 && ctcNum <= 10000000; // Max 1 crore
    };

    const validateYearsOfExp = (years) => {
        if (!years) return false;
        const yearsNum = Number(years);
        return !isNaN(yearsNum) && yearsNum >= 0 && yearsNum <= 50; // Max 50 years
    };

    const validateNoticePeriod = (days) => {
        if (!days) return false;
        const daysNum = Number(days);
        return !isNaN(daysNum) && daysNum >= 0 && daysNum <= 365; // Max 1 year
    };

    const validateText = (text, maxLength = 100) => {
        if (!text) return true;
        return text.length <= maxLength;
    };

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "expectedCTC",
            "yearofExp",
            // "applyingForPosition",
            "noticePeriod",
            "yearofExp",
            "availableToJoin",
            // formData.workedBefore === true ? "workedBeforeInfo" : null,
        ].filter(Boolean);
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        // Additional validations
        if (formData.currentCTC && !validateCTC(formData.currentCTC)) {
            newErrors.currentCTC = "Please enter a valid CTC amount (0 - 1 crore)!";
        }

        if (formData.monthlyinhand && !validateCTC(formData.monthlyinhand)) {
            newErrors.monthlyinhand = "Please enter a valid in-hand amount (0 - 1 crore)!";
        }

        if (formData.expectedCTC && !validateExpectedCTC(formData.expectedCTC)) {
            newErrors.expectedCTC = "Please enter a valid expected CTC (0 - 1 crore)!";
        }

        if (formData.yearofExp && !validateYearsOfExp(formData.yearofExp)) {
            newErrors.yearofExp = "Please enter valid years of experience (0 - 50 years)!";
        }

        if (formData.noticePeriod && !validateNoticePeriod(formData.noticePeriod)) {
            newErrors.noticePeriod = "Please enter valid notice period (0 - 365 days)!";
        }

        if (formData.areaOfInterest && !validateText(formData.areaOfInterest, 60)) {
            newErrors.areaOfInterest = "Area of interest should not exceed 60 characters!";
        }

        if (formData.availableToJoin && !validateText(formData.availableToJoin, 40)) {
            newErrors.availableToJoin = "Availability info should not exceed 40 characters!";
        }

        if (formData.bestAchieve && !validateText(formData.bestAchieve, 100)) {
            newErrors.bestAchieve = "Achievement text should not exceed 100 characters!";
        }

        if (formData.awardAchieve && !validateText(formData.awardAchieve, 100)) {
            newErrors.awardAchieve = "Award info should not exceed 100 characters!";
        }

        if (formData.accomplishments && !validateText(formData.accomplishments, 100)) {
            newErrors.accomplishments = "Accomplishments should not exceed 100 characters!";
        }

        // Worked before validation
        if (formData.workedBefore && !formData.workedBeforeInfo) {
            newErrors.workedBeforeInfo = "Please provide details about your previous employment!";
        }

        if (formData.workedBeforeInfo && formData.workedBeforeInfo.length > 300) {
            newErrors.workedBeforeInfo = "Previous employment details should not exceed 300 characters!";
        }

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };

    // Tooltip content
    const tooltipContent = {
        currentCTC: (
            <div className="tooltip-options-whitebg">
                <h4>Current CTC Rules</h4>
                <hr className="line" />
                <ul className="tooltip-list">
                    <li>Optional field</li>
                    <li>Enter your current monthly CTC</li>
                    <li>Must be a positive number</li>
                    <li>Maximum: 1 crore</li>
                    <li className="example">Example: 50000</li>
                    <li className="note">Note: Include all components</li>
                </ul>
            </div>
        ),
        monthlyinhand: (
            <div className="tooltip-options-whitebg">
                <h4>Monthly In-hand Rules</h4>
                <hr className="line" />
                <ul className="tooltip-list">
                    <li>Optional field</li>
                    <li>Enter your monthly take-home salary</li>
                    <li>Must be a positive number</li>
                    <li>Maximum: 1 crore</li>
                    <li className="example">Example: 45000</li>
                    <li className="note">Note: After all deductions</li>
                </ul>
            </div>
        ),
        expectedCTC: (
            <div className="tooltip-options-whitebg">
                <h4>Expected CTC Rules</h4>
                <hr className="line" />
                <ul className="tooltip-list">
                    <li>Required field</li>
                    <li>Enter your expected monthly CTC</li>
                    <li>Must be a positive number</li>
                    <li>Maximum: 1 crore</li>
                    <li className="example">Example: 60000</li>
                    <li className="note">Be realistic with expectations</li>
                </ul>
            </div>
        ),
        applyingForPosition: (
            <div className="tooltip-options-whitebg">
                <h4>Position Selection</h4>
                <hr className="line" />
                <ul className="tooltip-list">
                    <li>Required field</li>
                    <li>Select the position you're applying for</li>
                    <li>Choose from available openings</li>
                    <li className="note">Select carefully - affects your application</li>
                </ul>
            </div>
        ),
        areaOfInterest: (
            <div className="tooltip-options-whitebg">
                <h4>Area of Interest</h4>
                <hr className="line" />
                <ul className="tooltip-list">
                    <li>Optional field</li>
                    <li>Maximum 60 characters</li>
                    <li>Describe your preferred work domain</li>
                    <li className="example">Example: Frontend Development, Cloud Computing</li>
                </ul>
            </div>
        ),
        noticePeriod: (
            <div className="tooltip-options-whitebg">
                <h4>Notice Period Rules</h4>
                <hr className="line" />
                <ul className="tooltip-list">
                    <li>Required field</li>
                    <li>Enter notice period in days</li>
                    <li>Must be between 0 and 365 days</li>
                    <li className="example">Example: 30, 45, 60</li>
                    <li className="note">Affects joining date</li>
                </ul>
            </div>
        ),
        yearofExp: (
            <div className="tooltip-options-whitebg">
                <h4>Years of Experience</h4>
                <hr className="line" />
                <ul className="tooltip-list">
                    <li>Required field</li>
                    <li>Enter total years of experience</li>
                    <li>Must be between 0 and 50 years</li>
                    <li className="example">Example: 2, 5, 10</li>
                    <li className="note">Include all relevant experience</li>
                </ul>
            </div>
        ),
        availableToJoin: (
            <div className="tooltip-options-whitebg">
                <h4>Availability to Join</h4>
                <hr className="line" />
                <ul className="tooltip-list">
                    <li>Required field</li>
                    <li>Maximum 40 characters</li>
                    <li>Specify when you can start</li>
                    <li className="example">Example: Immediately, After 30 days, 15th June 2024</li>
                    <li className="note">Based on notice period</li>
                </ul>
            </div>
        ),
        workedBefore: (
            <div className="tooltip-options-whitebg">
                <h4>Previous Employment</h4>
                <hr className="line" />
                <ul className="tooltip-list">
                    <li>Check if you've worked here before</li>
                    <li>If checked, provide details</li>
                    <li>Include department, manager, dates, reason</li>
                    <li className="note">Details are mandatory if checked</li>
                </ul>
            </div>
        ),
        workedBeforeInfo: (
            <div className="tooltip-options-whitebg">
                <h4>Previous Employment Details</h4>
                <hr className="line" />
                <ul className="tooltip-list">
                    <li>Required if "Worked Before" is checked</li>
                    <li>Maximum 300 characters</li>
                    <li>Include: Department, Manager, Duration, Reason</li>
                    <li className="example">Example: Worked in IT department under John Doe from 2020-2022, left for higher studies</li>
                </ul>
            </div>
        ),
        bestAchieve: (
            <div className="tooltip-options-whitebg">
                <h4>Best Achievement</h4>
                <hr className="line" />
                <ul className="tooltip-list">
                    <li>Optional field</li>
                    <li>Maximum 100 characters</li>
                    <li>Describe your proudest professional achievement</li>
                    <li className="example">Example: Led a team of 10 to deliver project 2 months early</li>
                </ul>
            </div>
        ),
        awardAchieve: (
            <div className="tooltip-options-whitebg">
                <h4>Awards & Recognition</h4>
                <hr className="line" />
                <ul className="tooltip-list">
                    <li>Optional field</li>
                    <li>Maximum 100 characters</li>
                    <li>List any awards or recognition received</li>
                    <li className="example">Example: Employee of the Year 2023, Best Innovation Award</li>
                </ul>
            </div>
        ),
        accomplishments: (
            <div className="tooltip-options-whitebg">
                <h4>Accomplishments</h4>
                <hr className="line" />
                <ul className="tooltip-list">
                    <li>Optional field</li>
                    <li>Maximum 100 characters</li>
                    <li>Share accomplishments you're proud of</li>
                    <li className="example">Example: Successfully migrated legacy system to cloud, saving 30% costs</li>
                </ul>
            </div>
        ),
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleNumberInputChange = (e, max = null) => {
        const { name, value } = e.target;

        // Remove any non-numeric characters except empty string
        const numericValue = value.replace(/[^0-9]/g, '');

        // Apply max if specified
        let processedValue = numericValue;
        if (max && numericValue && parseInt(numericValue) > max) {
            processedValue = max.toString();
        }

        setInputState({
            ...inputState,
            [name]: processedValue ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: processedValue,
        });

        if (processedValue) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: checked,
            // Clear workedBeforeInfo when unchecked
            ...(name === 'workedBefore' && !checked ? { workedBeforeInfo: "" } : {})
        }));

        // Clear errors
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            if (name === 'workedBefore' && !checked) {
                delete updatedErrors.workedBeforeInfo;
            }
            return updatedErrors;
        });

    };


    // ?  ************** Validation End **************  ! //
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false); //loading logic

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            const updatedFormData = {
                ...formData,
                user: email,
            };

            try {
                let res = await axios.post(`${BASE_URL}/userdata/positiondata/`, updatedFormData,)

                if (res.status === 200) {
                    navigate(`/educationdetail/${id}/${email}/`)
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };


    const handleFormPut = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            const updatedFormData = {
                ...formData,
                user: email,
            };

            try {
                let res = await axios.put(`${BASE_URL}/userdata/positiondata/${email}/`, updatedFormData,)

                if (res.status === 200) {
                    navigate(`/educationdetail/${id}/${email}/`)
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    // const [jobposition, setJobPosition] = useState([])

    // const getJobpositionlist = async () => {
    //     setBuffering(true); //buffering logic // Start Buffering
    //     try {
    //         const res = await axios.get(`${BASE_URL}/jd/jobpostfilter/active/${sessionStorage.getItem("company_id")}/`);
    //         setJobPosition(res.data)
    //     } catch (err) {
    //         // handleErrorToast(err)
    //     } finally {
    //         setBuffering(false);// End Buffering
    //     }
    // };

    // useEffect(() => {
    //     getJobpositionlist();
    // }, []);

    const backroute = () => {
        navigate(`/personaldetails/${id}/${email}`)
    }

    return (
        <>
            {buffer ? <Loader /> : null}{/* //buffering logic */}
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

            <Careernavbar id={id} />
            <div className="career-form-container">
                <div className="career-stepper-container">
                    <div className="career-stepper-line"></div>
                    <CareerStepItem
                        step="1"
                        heading="Personal Information"
                        status="active"
                    />
                    <CareerStepItem
                        step="2"
                        heading="Position Information"
                        status="active"
                    />
                    <CareerStepItem
                        step="3"
                        heading="Education Detail"
                        status="pending"
                    />
                    <CareerStepItem
                        step="4"
                        heading="Work Experience"
                        status="pending"
                    />
                    <CareerStepItem
                        step="5"
                        heading="Documents Upload"
                        status="pending"
                    />
                </div>

                <div className="jd-heading-outer">
                    <h2 className="jd-heading-main font-weight600  font-size-heading">Position Information*</h2>
                    <div>
                        <div className="jd-heading-bottom-bold"></div>
                        <div className="jd-heading-bottom-light"></div>
                    </div>
                </div>

                <form className="register-form">
                    <div className="form-flex-wrap">

                        {/* Current CTC */}
                        <div className="flex-column width-flex-50">
                            <label htmlFor="currentCTC" className="form-labels  font-weight500    font-size-subheading">
                                <CustomTooltip position="top" tooltipContent={tooltipContent.currentCTC}>
                                    Monthly Current CTC
                                    {/* <InfoIcon /> */}
                                </CustomTooltip>
                            </label>
                            <input
                                type="text"
                                id="currentCTC"
                                name="currentCTC"
                                placeholder="Enter your current CTC"
                                onChange={(e) => handleNumberInputChange(e, 10000000)}
                                // min={0}
                                // step="1"
                                value={formData.currentCTC}
                                title={formData.currentCTC ? formatCurrencyIndian(formData.currentCTC) : ""}
                                className={`form-input width-respo ${errors.currentCTC ? "error" : inputState.currentCTC ? "success" : ""}`}
                            />
                            {errors.currentCTC && (
                                <span className="error-message font-size-text ">{errors.currentCTC}</span>
                            )}
                        </div>

                        {/* Monthly In-hand */}
                        <div className="flex-column width-flex-50">
                            <label htmlFor="monthlyinhand" className="form-labels  font-weight500    font-size-subheading">
                                <CustomTooltip position="top" tooltipContent={tooltipContent.monthlyinhand}>
                                    Monthly Current Inhand
                                    {/* <InfoIcon /> */}
                                </CustomTooltip>
                            </label>
                            <input
                                type="text"
                                id="monthlyinhand"
                                name="monthlyinhand"
                                placeholder="Enter your monthly Inhand"
                                onChange={(e) => handleNumberInputChange(e, 10000000)}
                                value={formData.monthlyinhand}
                                title={formData.monthlyinhand ? formatCurrencyIndian(formData.monthlyinhand) : ""}
                                className={`form-input width-respo ${errors.monthlyinhand ? "error" : inputState.monthlyinhand ? "success" : ""}`}
                            />
                            {errors.monthlyinhand && (
                                <span className="error-message font-size-text ">{errors.monthlyinhand}</span>
                            )}
                        </div>

                        {/* Expected CTC */}
                        <div className="flex-column width-flex-50">
                            <label htmlFor="expectedCTC" className="form-labels  font-weight500    font-size-subheading">
                                <CustomTooltip position="top" tooltipContent={tooltipContent.expectedCTC}>
                                    Monthly Expected CTC<span className="required">*</span>
                                    {/* <InfoIcon /> */}
                                </CustomTooltip>
                            </label>
                            <input
                                type="text"
                                id="expectedCTC"
                                name="expectedCTC"
                                placeholder="Enter your expected CTC"
                                onChange={(e) => handleNumberInputChange(e, 10000000)}
                                value={formData.expectedCTC}
                                title={formData.expectedCTC ? formatCurrencyIndian(formData.expectedCTC) : ""}
                                className={`form-input width-respo ${errors.expectedCTC ? "error" : inputState.expectedCTC ? "success" : ""}`}
                            />
                            {errors.expectedCTC && (
                                <span className="error-message font-size-text ">{errors.expectedCTC}</span>
                            )}
                        </div>


                        {/* Applying For Position */}
                        {/* <div className="flex-column width-flex-50">
                            <label htmlFor="applyingForPosition" className="form-labels font-weight500 font-size-subheading">
                                <CustomTooltip position="top" tooltipContent={tooltipContent.applyingForPosition}>
                                    Applying for Position<span className="required">*</span>
                                    <InfoIcon />
                                </CustomTooltip>
                            </label>
                            <select
                                id="applyingForPosition"
                                name="applyingForPosition"
                                value={formData.applyingForPosition}
                                onChange={handleInputChange}
                                className={`form-input width-respo ${errors.applyingForPosition ? "error" : inputState.applyingForPosition ? "success" : ""}`}
                            >
                                <option value="">Select Position</option>
                                {jobposition
                                    .sort((a, b) => a.department_name?.localeCompare(b.department_name))
                                    .map((i, index) => (
                                        <option key={index} value={i.position_name}>
                                            {i.department_name} - {i.position_name}
                                        </option>
                                    ))}
                            </select>
                            {errors.applyingForPosition && (
                                <span className="error-message font-size-text">{errors.applyingForPosition}</span>
                            )}
                        </div> */}

                        {/* Area of Interest */}
                        <div className="flex-column width-flex-50">
                            <label htmlFor="areaOfInterest" className="form-labels  font-weight500    font-size-subheading">
                                <CustomTooltip position="top" tooltipContent={tooltipContent.areaOfInterest}>
                                    Area of Interest
                                    {/* <InfoIcon /> */}
                                </CustomTooltip>
                            </label>
                            <input
                                type="text"
                                id="areaOfInterest"
                                name="areaOfInterest"
                                placeholder="Enter your area of interest"
                                onChange={handleInputChange}
                                maxLength={60}
                                value={formData.areaOfInterest}
                                className={`form-input width-respo ${errors.areaOfInterest ? "error" : inputState.areaOfInterest ? "success" : ""}`}
                            />
                            {errors.areaOfInterest && (
                                <span className="error-message font-size-text ">{errors.areaOfInterest}</span>
                            )}
                        </div>

                        {/* Notice Period */}
                        <div className="flex-column width-flex-50">
                            <label htmlFor="noticePeriod" className="form-labels  font-weight500    font-size-subheading">
                                <CustomTooltip position="top" tooltipContent={tooltipContent.noticePeriod}>
                                    Notice Period (days)<span className="required">*</span>
                                    {/* <InfoIcon /> */}
                                </CustomTooltip>
                            </label>
                            <input
                                type="text"
                                id="noticePeriod"
                                name="noticePeriod"
                                placeholder="Enter your notice period in days"
                                onChange={(e) => handleNumberInputChange(e, 365)}
                                value={formData.noticePeriod}
                                className={`form-input width-respo ${errors.noticePeriod ? "error" : inputState.noticePeriod ? "success" : ""}`}
                            />
                            {errors.noticePeriod && (
                                <span className="error-message font-size-text ">{errors.noticePeriod}</span>
                            )}
                        </div>

                        {/* Years of Experience */}
                        <div className="flex-column width-flex-50">
                            <label htmlFor="yearofExp" className="form-labels  font-weight500    font-size-subheading">
                                <CustomTooltip position="top" tooltipContent={tooltipContent.yearofExp}>
                                    Year of Experience ?<span className="required">*</span>
                                    {/* <InfoIcon /> */}
                                </CustomTooltip>
                            </label>
                            <input
                                type="text"
                                id="yearofExp"
                                name="yearofExp"
                                placeholder="Enter years of Experience"
                                onChange={(e) => handleNumberInputChange(e, 50)}
                                value={formData.yearofExp}
                                className={`form-input width-respo ${errors.yearofExp ? "error" : inputState.yearofExp ? "success" : ""}`}
                            />
                            {errors.yearofExp && (
                                <span className="error-message font-size-text ">{errors.yearofExp}</span>
                            )}
                        </div>

                        {/* Available to Join */}
                        <div className="flex-column width-flex-50">
                            <label htmlFor="availableToJoin" className="form-labels  font-weight500    font-size-subheading">
                                <CustomTooltip position="top" tooltipContent={tooltipContent.availableToJoin}>
                                    When can you join?<span className="required">*</span>
                                    {/* <InfoIcon /> */}
                                </CustomTooltip>
                            </label>
                            <input
                                type="text"
                                id="availableToJoin"
                                name="availableToJoin"
                                placeholder="Enter your availability"
                                onChange={handleInputChange}
                                maxLength={40}
                                value={formData.availableToJoin}
                                className={`form-input width-respo ${errors.availableToJoin ? "error" : inputState.availableToJoin ? "success" : ""}`}
                            />
                            {errors.availableToJoin && (
                                <span className="error-message font-size-text ">{errors.availableToJoin}</span>
                            )}
                        </div>
                    </div>

                    {/* Worked Before */}
                    <div className="flex-column ">

                        <div className="flex-row ">
                            <label htmlFor="workedBefore" className="form-labels  font-weight500    font-size-subheading">
                                <CustomTooltip position="top" tooltipContent={tooltipContent.workedBefore}>
                                    <span className="">Have you worked for the company before?</span>
                                    {/* <InfoIcon /> */}
                                </CustomTooltip>
                            </label>
                            <hr className="field-cont-hr" />
                            <label className="checkbox-click">
                                <input
                                    type="checkbox"
                                    id="workedBefore"
                                    name="workedBefore"
                                    checked={formData.workedBefore}
                                    onChange={handleCheckboxChange}
                                />
                                <div className="checkmark-medium "></div>
                            </label>
                        </div>

                        {formData.workedBefore &&
                            (<>
                                <div className="flex-column ">
                                    <label className="form-labels-grey  font-weight500    font-size-subheading">
                                        <CustomTooltip position="top" tooltipContent={tooltipContent.workedBeforeInfo}>
                                            Please provide department, manager, duration, and reason for leaving
                                            <span className="required">*</span>
                                            {/* <InfoIcon /> */}
                                        </CustomTooltip>
                                    </label>
                                    <textarea
                                        id="workedBeforeInfo"
                                        name="workedBeforeInfo"
                                        placeholder="Enter details..."
                                        onChange={handleInputChange}
                                        value={formData.workedBeforeInfo}
                                        maxLength={300}
                                        className={`form-input width-respo-textarea width-respo font-weight400  font-size-subheading`}
                                    />
                                    {errors.workedBeforeInfo && (
                                        <span className="error-message font-size-text">{errors.workedBeforeInfo}</span>
                                    )}
                                </div>
                            </>)
                        }
                    </div>
                </form >

                <div className="jd-heading-outer">
                    <h2 className="jd-heading-main font-weight600  font-size-heading">Achievement Details</h2>
                    <div>
                        <div className="jd-heading-bottom-bold"></div>
                        <div className="jd-heading-bottom-light"></div>
                    </div>
                </div>

                <form className="register-form">
                    <div className="form-flex-wrap">

                        {/* Best Achievement */}
                        <div className="flex-column width-flex-50">
                            <label htmlFor="bestAchieve" className="form-labels  font-weight500    font-size-subheading">
                                <CustomTooltip position="top" tooltipContent={tooltipContent.bestAchieve}>
                                    What is your best achievement?
                                    {/* <InfoIcon /> */}
                                </CustomTooltip>
                            </label>
                            <input
                                type="text"
                                id="bestAchieve"
                                name="bestAchieve"
                                placeholder="Enter your best achievement"
                                onChange={handleInputChange}
                                maxLength={100}
                                value={formData.bestAchieve}
                                className={`form-input width-respo ${errors.bestAchieve ? "error" : inputState.bestAchieve ? "success" : ""}`}
                            />
                            {errors.bestAchieve && (
                                <span className="error-message font-size-text ">{errors.bestAchieve}</span>
                            )}
                        </div>

                        {/* Award Achievement */}
                        <div className="flex-column width-flex-50">
                            <label htmlFor="awardAchieve" className="form-labels  font-weight500    font-size-subheading">
                                <CustomTooltip position="top" tooltipContent={tooltipContent.awardAchieve}>
                                    Any awards or recognition?
                                    {/* <InfoIcon /> */}
                                </CustomTooltip>
                            </label>
                            <input
                                type="text"
                                id="awardAchieve"
                                name="awardAchieve"
                                maxLength={100}
                                placeholder="Enter award details"
                                onChange={handleInputChange}
                                value={formData.awardAchieve}
                                className={`form-input width-respo ${errors.awardAchieve ? "error" : inputState.awardAchieve ? "success" : ""}`}
                            />
                            {errors.awardAchieve && (
                                <span className="error-message font-size-text ">{errors.awardAchieve}</span>
                            )}
                        </div>

                        <div className="flex-column width-flex-50">
                            <label htmlFor="accomplishments" className="form-labels  font-weight500    font-size-subheading">
                                <CustomTooltip position="top" tooltipContent={tooltipContent.accomplishments}>
                                    Other accomplishments?
                                    {/* <InfoIcon /> */}
                                </CustomTooltip>
                            </label>
                            <input
                                type="text"
                                id="accomplishments"
                                name="accomplishments"
                                maxLength={100}
                                placeholder="Enter accomplishments"
                                onChange={handleInputChange}
                                value={formData.accomplishments}
                                className={`form-input width-respo ${errors.accomplishments ? "error" : inputState.accomplishments ? "success" : ""}`}
                            />
                            {errors.accomplishments && (
                                <span className="error-message font-size-text ">{errors.accomplishments}</span>
                            )}
                        </div>

                    </div>
                    <div className="button-models">
                        <button className="model-button model-button-cancel  font-weight500   " onClick={backroute} disabled={loading}>
                            Back
                        </button>

                        {data ? (
                            <button onClick={handleFormPut} className="model-button   font-weight500    model-button-submit" disabled={loading} >
                                {loading ? "Updating..." : "Submit & Proceed"}
                            </button>
                        ) : (
                            <button onClick={handleFormSubmit} className="model-button   font-weight500    model-button-submit" disabled={loading} >
                                {loading ? "Saving..." : "Next"}
                            </button>
                        )}
                    </div>
                    <p className="error-message font-size-text">
                        {isSubmitted && Object.keys(errors).length > 0 && (
                            Object.keys(errors).length > 5 ? (
                                <h5 className="text-center">Please fill all mandatory fields!</h5>
                            ) : (
                                <h6 className="text-center">
                                    {Object.keys(errors).map((field) =>
                                        field.charAt(0).toUpperCase() + field.slice(1)
                                    ).join(', ') + ' are required!'}
                                </h6>
                            )
                        )}
                    </p>
                </form>
            </div >
        </>
    );
};


const EducationDetail = () => {
    let { id, email } = useParams()

    return (

        <>
            <Careernavbar id={id} />
            <div className="career-form-container">
                <div className="career-stepper-container">
                    <div className="career-stepper-line"></div>
                    <CareerStepItem
                        step="1"
                        heading="Personal Information"
                        status="active"
                    />
                    <CareerStepItem
                        step="2"
                        heading="Position Information"
                        status="active"
                    />
                    <CareerStepItem
                        step="3"
                        heading="Education Detail"
                        status="active"
                    />
                    <CareerStepItem
                        step="4"
                        heading="Work Experience"
                        status="pending"
                    />
                    <CareerStepItem
                        step="5"
                        heading="Documents Upload"
                        status="pending"
                    />
                </div>
                <EducationdetailsAdd
                    email={email}
                    id={id}
                    forwardroutepath="workexprience"
                    backroutepath="positiondetails"
                />
            </div>

        </>
    );
};

const Workexprience = () => {

    let { id, email } = useParams()
    return (

        <>
            <Careernavbar id={id} />
            <div className="career-form-container">
                <div className="career-stepper-container">
                    <div className="career-stepper-line"></div>
                    <CareerStepItem
                        step="1"
                        heading="Personal Information"
                        status="active"
                    />
                    <CareerStepItem
                        step="2"
                        heading="Position Information"
                        status="active"
                    />
                    <CareerStepItem
                        step="3"
                        heading="Education Detail"
                        status="active"
                    />
                    <CareerStepItem
                        step="4"
                        heading="Work Experience"
                        status="active"
                    />
                    <CareerStepItem
                        step="5"
                        heading="Documents Upload"
                        status="pending"
                    />
                </div>
                <WorkexperienceAdd email={email} id={id} forwardroutepath="document" backroutepath="educationdetail" />
            </div>

        </>
    );
};

const DocumentdetailsPage = () => {
    let { id, email } = useParams()
    return (
        <>
            <Careernavbar id={id} />
            <div className="career-form-container">
                <div className="career-stepper-container">
                    <div className="career-stepper-line"></div>
                    <CareerStepItem
                        step="1"
                        heading="Personal Information"
                        status="active"
                    />
                    <CareerStepItem
                        step="2"
                        heading="Position Information"
                        status="active"
                    />
                    <CareerStepItem
                        step="3"
                        heading="Education Detail"
                        status="active"
                    />
                    <CareerStepItem
                        step="4"
                        heading="Work Experience"
                        status="active"
                    />
                    <CareerStepItem
                        step="5"
                        heading="Documents Upload"
                        status="active"
                    />
                </div>
                <Documentdetails email={email} id={id} backroutepath="workexprience" />
            </div>

        </>
    );
};


export { Personaldetails, Positiondetails, EducationDetail, Workexprience, DocumentdetailsPage };
